<template>
    <div class="menu-padding flex flex-col">
        <header class="flex items-center justify-center scroll-reveal relative">
            <div class="-z-1 absolute inset-0">
                <template v-if="hasNews">
                    <figure
                        class="hero-background _overlay"
                        :class="isActive(newsItem.id) ? 'active' : ''"
                        v-for="newsItem in featuredNews"
                        :key="newsItem.id"
                        :style="{
                            backgroundImage: `url('${newsItem.hero_image}')`,
                        }"
                    ></figure>
                </template>
                <figure
                    v-else-if="fallbackImage"
                    class="hero-background _overlay active"
                    :style="{
                        backgroundImage: `url('${fallbackImage}')`,
                    }"
                ></figure>
            </div>

            <div
                class="hero-content flex justify-between flex-col sm:flex-row text-white w-10/12"
            >
                <div class="main-news xl:mr-8 flex flex-col w-full">
                    <div class="flex items-center justify-between">
                        <div
                            class="hidden mr-4 w-5/6 xl:w-7/12 lg:block"
                            @click="goToNews()"
                            v-if="mainNews"
                        >
                            <span class="p-3 bg-primary text-white text-sm">{{
                                isFeaturedDefault
                            }}</span>
                            <span
                                class="ml-4 text-sm"
                                v-text="mainNews.formatted_valid_from"
                            ></span>
                            <h2
                                class="font-medium text-xl sm:text-3xl mt-8 mr-2 block cursor-pointer"
                                v-text="mainNews.title"
                            ></h2>
                            <div
                                class="main-content"
                                v-html="mainNews.excerpt"
                            ></div>
                        </div>

                        <div class="xl:ml-12 xl:ml-32">
                            <div
                                class="hero-news-list mt-10 sm:min-w-68 sm:mt-0 hidden lg:block cursor-pointer"
                            >
                                <div
                                    class="hero-news-item"
                                    :class="
                                        isActive(newsItem.id) ? 'active' : ''
                                    "
                                    v-for="newsItem in featuredNews"
                                    :key="newsItem.id"
                                    @click="setMainNews(newsItem)"
                                >
                                    <h3
                                        class="text-xl pb-1"
                                        v-text="newsItem.title"
                                    ></h3>
                                    <span
                                        class="text-xs font-light"
                                        v-text="newsItem.formatted_valid_from"
                                    ></span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="lg:hidden pt-12" v-if="hasNews">
                        <carousel
                            :per-page="1"
                            :pagination-enabled="false"
                            @pageChange="pageChangeEvent"
                        >
                            <slide
                                v-for="newsItem in featuredNews"
                                :key="newsItem.id"
                                class="my-auto"
                            >
                                <div
                                    class="flex flex-col justify-center max-w-5/6 sm:max-w-4/5 mx-auto"
                                    @click="goToNews()"
                                >
                                    <div class="mr-auto pt-4">
                                        <span
                                            class="p-3 bg-primary text-white text-sm"
                                            >{{ isFeaturedDefault }}</span
                                        >
                                        <span
                                            class="ml-8 mt-8 text-sm"
                                            v-text="newsItem.date"
                                        ></span>
                                    </div>
                                    <h2
                                        class="font-medium text-xl sm:text-3xl mt-8"
                                        v-text="newsItem.title"
                                    ></h2>
                                </div>
                            </slide>
                        </carousel>

                        <div
                            class="mt-12 sm:mt-32 flex max-w-full items-center"
                        >
                            <span
                                v-text="slideCount"
                                class="text-sm pt-2 w-1/2"
                            ></span>
                            <div class="swipe">
                                <img src="svg/swipe.svg" class="swipe-img" />
                                <div class="swipe-line"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <a
                    v-if="hasNews"
                    class="absolute bottom-4 sm:left-0 right-4 sm:right-0 m-auto w-32 sm:max-w-10/12 xl:max-w-7xl sm:w-full text-center md:text-left px-2 md:px-8"
                    :href="route('public-relation.news.list')"
                    >{{ 'Pogledaj sve novosti' | trans }}</a
                >
            </div>
        </header>
    </div>
</template>

<script>
export default {
    name: "MainNews",
    props: ["featuredNews", "isFeatured", "fallbackImage"],
    data() {
        return {
            mainNews: null,
            currentNumber: 1,
            isFeaturedDefault: "",
        };
    },

    created() {
        if (this.featuredNews) {
            this.mainNews = this.featuredNews[0];
        }
        if (this.isFeatured) {
            this.isFeaturedDefault = this.isFeatured;
        }
    },

    computed: {
        hasNews() {
            return this.featuredNews && this.featuredNews.length > 0;
        },

        totalNews() {
            return this.featuredNews ? this.featuredNews.length : 0;
        },

        slideCount() {
            return (
                this.zeroFill(this.currentNumber, 2) +
                "/" +
                this.zeroFill(this.totalNews, 2)
            );
        },
    },

    methods: {
        isActive(id) {
            return this.mainNews.id == id;
        },

        setMainNews(news) {
            this.mainNews = news;
        },

        goToNews() {
            let slug = this.mainNews.slug;
            window.location.href = route("public-relation.news.item", {
                slug: slug,
            });
        },

        zeroFill(number, width) {
            width -= number.toString().length;

            if (width > 0) {
                return (
                    new Array(width + (/\./.test(number) ? 2 : 1)).join("0") +
                    number
                );
            }

            return number + "";
        },

        pageChangeEvent(index) {
            if (window.innerWidth < 1024) {
                this.currentNumber = Math.abs(index + 1);
                this.mainNews = this.featuredNews[Math.abs(index)];
            }
        },
    },
};
</script>
